<template>
    <div>
        <CCol sm="12">
            <div style="width:50%;padding:20px;padding-top:30px" class="text-left">
                <img style="max-width: 40px;" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            </div>
            <CRow class="m-0 justify-content-center align-items-center">
                <img style="max-width:80%" src="../assets/img/datetime.png" />
                <h3 class="custom-header-location mt-4">
                    Choose Date /Time
                </h3> <CCol sm="8" class="text-center mt-3" style="width: 90%; background-size: cover; margin: auto;">
                <CRow>
                        <h3 class="custom-12px text-left">Schedule</h3>
                        <input type="date" placeholder="Choose Your Date" class="custom-input-app"/>

                        <h3 class="custom-12px text-left mt-3">Time</h3>
                        <input type="time" placeholder="Choose Your Time" class="custom-input-app"/>
               
                    <div style="width:100%; margin: 0 auto">
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="OpenPopup()">Continue</CButton>
                </div>
                
                </CRow>
                <br /><br /> <br /><br />
            </CCol>
            </CRow>

          
    
        </CCol>
        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all" @click="closePopup">
      <div class="popup-all1">
        <!-- Popup content -->
        <div class="text-center">
        <img style="max-width:100%" src="../assets/img/load.png" />
        <h3 class="custom-18px text-center">Submitting</h3>
        <p class="custom-12px text-center">Start a new chat and connect <br />
            with someone new.</p>
    </div>
      </div>
    </div>
    <MainlayoutBottom></MainlayoutBottom>
    </div>
</template>


<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
export default ({
    components: {
    MainlayoutBottom,
  },
    data() {
        return {
            isLanguagePopupVisible: false,

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
        OpenPopup() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        closePopup() {
    this.isLanguagePopupVisible = false;
    this.$router.push("FindServices");
  },

    }
})
</script>
